<template>
  <v-container>
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-card-text>
            <v-alert :value="error" type="error" outline>{{ errorMessage }}</v-alert>
            <v-container>
              <form @submit.prevent="authenticate">
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field name="username" label="Usuario" id="id_username" v-model="username" type="text"
                                  required prepend-inner-icon="account_circle"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field name="password" label="Contraseña" id="password" v-model="password" type="password"
                                  required prepend-inner-icon="lock"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout column>
                  <v-flex xs12 pb-2>
                    <v-btn color="primary" type="submit">Ingresar</v-btn>
                  </v-flex>
                  <a @click="openPasswordResetPopup">¿Olvidó su contraseña?</a>
                </v-layout>
              </form>
              <request-password-reset ref="resetPasswordPopup"></request-password-reset>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import RequestPasswordReset from './RequestPasswordReset.vue'

export default {

  components: {
    RequestPasswordReset
  },

  data () {
    return {
      username: '',
      password: '',
      error: false,
      errorMessage: ''
    }
  },

  methods: {
    authenticate () {
      const payload = {
        username: this.username,
        password: this.password
      }
      this.axios
        .post('auth/obtain_token/', payload)
        .then((response) => {
          this.$store.commit('updateToken', response.data.token)
          this.$store.commit('setAuthUser', payload.username)
          this.$store.commit('updateHeader')
          this.$store.dispatch('fetchUserRole')
        })
        .catch((error) => {
          this.error = true
          if (error && error.response && error.response.status === 400) {
            this.errorMessage = 'Credenciales de acceso inválidas'
          } else {
            this.errorMessage = 'Error de conexión con el servidor'
          }
        })
    },
    openPasswordResetPopup () {
      this.$refs.resetPasswordPopup.showDialog()
    }
  }
}
</script>
